<!-- Loading bar -->
<fuse-loading-bar></fuse-loading-bar>
<!-- Navigation -->
<ng-container *ngIf="isScreenSmall">
    <div *ngIf="loggedIn">
        <fuse-vertical-navigation class="bg-white print:hidden" [mode]="'over'" [name]="'mainNavigation'"
            [navigation]="navigation.defaultLogin" [opened]="false">
            <!-- Navigation header hook -->
            <ng-container fuseVerticalNavigationHeader>
                <!-- Logo -->
                <div class="flex flex-row items-center h-20 py-6 px-8">
                    <img class="w-full" src="assets/images/logo/logo.svg" alt="Logo image" loading="lazy">
                </div>

            </ng-container>
            <ng-container fuseVerticalNavigationFooter>
                
                <!-- Log in-out -->
                 <div class="bg-primary">
                    <button mat-button class=" text-primary mx-2 bg-accent my-8 font-bold" mat-flat-button (click)="onCheckCoverageClick()" mat-flat-button>
                        Check Coverage
                    </button>
                 </div>
                <!-- Log in-out -->
                 <div class="bg-primary">
                    <button mat-button class=" text-primary mx-2 bg-primary-50 my-2 font-bold justify-end" mat-flat-button (click)="signOut()">
                        Log Out
                    </button>
                 </div>
            </ng-container>
        </fuse-vertical-navigation>
    </div>

    <div *ngIf="!loggedIn">
        <fuse-vertical-navigation class="bg-white print:hidden" [mode]="'over'" [name]="'mainNavigation'" 
            [navigation]="navigation.default" [opened]="false" #mainNavigation (openedChange)="onSidenavOpenedChange($event)">
            <!-- Navigation header hook -->
            <ng-container fuseVerticalNavigationHeader>
                <!-- Logo -->
                <div class="flex flex-row items-center h-20 py-6 px-8 hover:cursor-pointer" [routerLink]="['/']">
                    <img class="w-full" src="assets/images/logo/logo.svg" alt="Logo image" loading="lazy">
                </div>
            </ng-container>
            <ng-container fuseVerticalNavigationContentFooter *ngIf="coverageVisibilityService.isInputOutOfView$.value">
                <!-- Log in-out -->
                <button mat-button class=" text-primary mx-2 bg-accent my-8 font-bold" mat-flat-button (click)="onCheckCoverageClick()" mat-flat-button>
                    Check Coverage
                </button>
            </ng-container>
            <ng-container fuseVerticalNavigationFooter>
                <!-- Log in-out -->
                <button mat-button class=" text-primary mx-2 bg-primary-50 my-8 font-bold" mat-flat-button [routerLink]="['/sign-in']" >
                    Log In/Register
                </button>
            </ng-container>
        </fuse-vertical-navigation>
    </div>
</ng-container>
<!-- Wrapper -->
<div class="flex-col flex-auto items-center w-full min-w-0 dark:bg-card">
    <!-- Header -->
    <div class="sticky top-0 flex flex-col flex-0 justify-center w-full overflow-hidden z-[998] shadow dark:shadow-none print:hidden">
        <!-- Top bar -->
        <div class="relative dark justify-center w-full px-4 md:px-8 bg-secondary-200 dark:bg-gray-900">
            <div class="flex items-center w-full h-16 sm:h-20 justify-between">
                
                <ng-container *ngIf="!isScreenSmall">
                    <!-- Logo -->
                    <div class="flex flex-row items-center px-8 w-full ">
                        <img [routerLink]="['/']" class="w-50 h-50 hover:cursor-pointer" src="assets/images/logo/logo.svg" alt="Logo image" loading="lazy">
                    </div>
                    <div class="flex justify-end ">
                        <!-- <app_network_panel></app_network_panel> -->
                        <!-- Speed Test Icon -->
                        <!-- <button class="purple-button font-semibold py-2 px-6 mr-2 hover:bg-secondary-500" aria-label="Speed Test" (click)="openSpeedTest()">
                            <mat-icon class="icon-colour" svgIcon="mat_solid:speed"></mat-icon>
                        </button> -->
                        <button *ngIf="showCart()" class="purple-button font-semibold py-2 px-6 mr-2 hover:bg-secondary-500" aria-label="Go to cart" [routerLink]="['/confirm-order']">
                            <mat-icon class="icon-colour" matBadgeColor="accent" matBadge="{{cartValue !== 0 ? cartValue : ''}}" svgIcon="heroicons_solid:shopping-cart"></mat-icon>
                        </button>
                        <!-- Notifications icon -->
                        <ng-container *ngIf="loggedIn && notifications?.length > 0">
                            <button class="purple-button font-semibold py-2 px-6 mr-2 hover:bg-secondary-500 notification-icon-animated" aria-label="Notifications" [matMenuTriggerFor]="notificationsMenu">
                                <mat-icon class="icon-colour" [matBadgeColor]="'accent'" matBadge="{{notifications?.length ?? ''}}" svgIcon="heroicons_solid:bell"></mat-icon>
                            </button>

                            <mat-menu #notificationsMenu="matMenu" class="notification-menu">
                                <button mat-menu-item
                                        *ngFor="let notification of notifications"
                                        (click)="onNotificationClick(notification)">
                                    <div class="w-fit flex flex-row whitespace-nowrap items-center ">
                                        <div class="notification-icon">
                                            <mat-icon class="text-red-500" [svgIcon]="'heroicons_outline:exclamation-circle'"></mat-icon>
                                        </div>
                                        <div class="notification-text">
                                            {{notification.notificationName}}
                                        </div>
                                    </div>
                                </button>
                                <div *ngIf="notifications.length === 0" class="notification-empty">
                                    <mat-icon [svgIcon]="'heroicons_outline:bell-slash'"></mat-icon>
                                    <span>No notifications</span>
                                </div>
                            </mat-menu>
                        </ng-container>
                        <ng-container *ngIf="loggedIn">
                            <button  [matMenuTriggerFor]="accountMenu" class="purple-button font-semibold p-2 rounded-full ">
                                {{shortenedProfileDisplay}}
                            </button>
                            
                            <div class="flex align-center justify-between items-center">
                                <mat-icon class="text-black icon-size-8 hover:cursor-pointer " svgIcon="mat_solid:arrow_drop_down" [matMenuTriggerFor]="accountMenu"></mat-icon>
                            </div>
                            
                            <mat-menu #accountMenu="matMenu" class="pb-0 rounded-md">                                
                                <button mat-menu-item (click)="menuItemClick('dashboard')">
                                    <p class="font-semibold">Dashboard</p>
                                </button>
                                <button mat-menu-item (click)="menuItemClick('dashboard','profile')">
                                    <p class="font-semibold">My Profile</p>
                                </button>
                                <button mat-menu-item [matMenuTriggerFor]="billingAndInvoices" (click)="menuItemClick('dashboard','invoices')">
                                    <p class="font-semibold">Billing</p>
                                </button>
                                <button mat-menu-item class="purple-menu-item" (click)="signOut()">
                                    <p class="text-primary font-bold">Logout</p>
                                </button>
                            </mat-menu>
                            <mat-menu #billingAndInvoices="matMenu">
                                <button mat-menu-item (click)="menuItemClick('dashboard','invoices', 'billing')">
                                    <p class="font-semibold">Billing</p>
                                </button>
                                <button mat-menu-item (click)="menuItemClick('dashboard','invoices', 'statements')">
                                    <p class="font-semibold">Statements</p>
                                </button>
                                <button mat-menu-item (click)="menuItemClick('dashboard','invoices', 'invoices')">
                                    <p class="font-semibold">Invoices</p>
                                </button>
                                <button mat-menu-item (click)="menuItemClick('balances')">
                                    <p class="font-semibold">Balances</p>
                                </button>
                              </mat-menu>                           
                        </ng-container>
                        <ng-container *ngIf="!loggedIn">
                            <button class="purple-button font-semibold py-2 px-6" (click)="signIn()">
                                <mat-icon class="icon-colour" svgIcon="heroicons_solid:user"></mat-icon>Login
                            </button>
                        </ng-container>
                        
                    </div>
                </ng-container>
                <!-- Navigation toggle button -->
                <ng-container *ngIf="isScreenSmall">
                    <div class="w-full flex flex-row justify-between items-center">
                        <div>
                            <button
                                mat-icon-button
                                (click)="toggleNavigation('mainNavigation')">
                                <mat-icon  [svgIcon]="'heroicons_outline:bars-3'"></mat-icon>
                            </button>
                        </div>
    
                        <div>
                            <img [routerLink]="['/']" class="w-36 hover:cursor-pointer mt-2" src="assets/images/logo/logo.svg" alt="Logo image" loading="lazy">
                        </div>

                        <div class="flex flex-row items-center space-x-2">
                            <!-- Cart Icon (always visible) -->
                            <button *ngIf="showCart()" class="flex flex-row items-center justify-center w-10 h-10 rounded-full hover:bg-gray-100 transition-colors" [routerLink]="['/confirm-order']">
                                <mat-icon class="icon-size-5 text-primary-500" svgIcon="heroicons_solid:shopping-cart"></mat-icon>
                            </button>
                            
                            <!-- More Menu Button (contains Speed Test, Notifications, etc.) -->
                            <button class="flex flex-row items-center justify-center w-10 h-10 rounded-full hover:bg-gray-100 transition-colors" [matMenuTriggerFor]="mobileMenu">
                                <mat-icon class="icon-size-5 text-primary-500" svgIcon="heroicons_outline:ellipsis-vertical"></mat-icon>
                            </button>

                            <!-- More Menu Dropdown -->
                            <mat-menu #mobileMenu="matMenu" class="mobile-menu">
                                <!-- Speed Test -->
                                <!-- <button mat-menu-item (click)="openSpeedTest()">
                                    <mat-icon class="text-primary-500 mr-3" svgIcon="mat_solid:speed"></mat-icon>
                                    <span>Speed Test</span>
                                </button> -->
                                
                                <!-- Notifications -->
                                <ng-container *ngIf="loggedIn && notifications?.length > 0">
                                    <button mat-menu-item [matMenuTriggerFor]="notificationsMenuMobile">
                                        <mat-icon class="text-primary-500 mr-3" [matBadgeColor]="'accent'" matBadge="{{notifications.length}}" svgIcon="heroicons_solid:bell"></mat-icon>
                                        <span>Notifications</span>
                                    </button>
                                </ng-container>
                                
                                <!-- Dashboard (for logged in users) -->
                                <button *ngIf="loggedIn" mat-menu-item [routerLink]="['/dashboard']">
                                    <mat-icon class="text-primary-500 mr-3" svgIcon="heroicons_solid:user"></mat-icon>
                                    <span>Dashboard</span>
                                </button>
                                
                                <!-- Login (for non-logged in users) -->
                                <button *ngIf="!loggedIn" mat-menu-item [routerLink]="['/sign-in']">
                                    <mat-icon class="text-primary-500 mr-3" svgIcon="heroicons_solid:user"></mat-icon>
                                    <span>Login</span>
                                </button>
                            </mat-menu>

                            <!-- Notifications Menu (nested) -->
                            <mat-menu class="z-999 notification-menu" #notificationsMenuMobile="matMenu">
                                <button mat-menu-item
                                        *ngFor="let notification of notifications"
                                        (click)="onNotificationClick(notification)">
                                    <div class="notification-content">
                                        <div class="notification-text">
                                            {{notification.notificationName}}
                                        </div>
                                    </div>
                                </button>
                                <div *ngIf="notifications.length === 0" class="notification-empty">
                                    <mat-icon [svgIcon]="'heroicons_outline:bell-slash'"></mat-icon>
                                    <span>No notifications</span>
                                </div>
                            </mat-menu>
                        </div>

                    </div>
                </ng-container>
            </div>
        </div>
        <!-- Menu bar -->
        <ng-container *ngIf="!isScreenSmall">
            <div class="flex flex-auto px-4 md:px-8 bg-primary-500 dark:bg-gray-700 text-white py-4"
                 [ngClass]="{'group show-coverage': showCoverageButton}">
                <div class="items-center w-full max-w-full px-10">
                    <fuse-horizontal-navigation [name]="'mainNavigation'" [navigation]="navigation.horizontalLoggedIn"></fuse-horizontal-navigation>
                </div>
            </div>
        </ng-container>
    </div>

    <!-- Content -->
    <div class="flex-auto justify-center w-full overflow-hidden">
        <router-outlet *ngIf="true"></router-outlet>
    </div>

    <app-footer (focusInput)="focusOnSearch()"></app-footer>

</div>

<ng-template #inActivityDialog>

  <div>
    <div class="flex flex-col justify-center items-center">
      <mat-icon class="text-primary icon-size-10" svgIcon="heroicons_outline:cursor-arrow-rays"></mat-icon>
      <h1 class="font-extrabold text-xl py-6">
        Inactivity detected.
      </h1>
    </div>
    <h2 class="text-sm text-center pb-6">
      You will be signed out in <span class="font-bold">{{countDownValue}}</span> seconds.
    </h2>

    <div class="flex justify-end">
        <button
            class="flex flex-row justify-center items-center"
            [color]="'primary'"
            type="button"
            (click)="resetInactivityTimer()"
            mat-flat-button
        >
            Don't sign me out!
        </button>
    </div>
  </div>

</ng-template>